import { WebElement, } from 'z3k-config';
import { getFieldParser, number_or_0, objectid_or_null, physical_converters, string_or_empty, } from '../../utils/parser-utils';
const web_element_fields = [
    { name: 'name', ...string_or_empty },
    { name: 'type', ...number_or_0 },
    { name: 'label1', ...string_or_empty },
    { name: 'label2', ...string_or_empty },
    { name: 'setting_register', ...number_or_0 },
    {
        name: 'id_active',
        ...physical_converters,
    },
    {
        name: 'id_passive',
        ...objectid_or_null,
        default_from_op: 0,
    },
    { name: 'position', ...number_or_0 },
    { name: 'alice_view', ...number_or_0 },
];
const { fromStr, toStr } = getFieldParser(web_element_fields);
function webElementsFromString(id, params) {
    let id_active = params[5];
    switch (id_active) {
        case 0:
            if (params[1] === WebElement.Type.COMPLEX ||
                (params[1] === WebElement.Type.STATUS &&
                    (params[4] & 1) === 0)) {
                id_active = null;
            }
            break;
        case 255:
            if (params[1] === WebElement.Type.STATUS &&
                (params[4] & 1) == 0) {
                id_active = -1;
            }
            break;
    }
    return {
        ...fromStr(id, params),
        id_active: id_active,
    };
}
export const web_element_parser = {
    toStr: toStr,
    fromStr: webElementsFromString,
};
